function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "87",
  height: "87",
  viewBox: "0 0 87 87",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.66 35.54c-4.123 23.388 11.493 45.69 34.88 49.814 23.388 4.124 45.69-11.492 49.814-34.88C89.478 27.087 73.862 4.784 50.474.66 27.087-3.463 4.784 12.153.66 35.54zM50.126 2.63c22.3 3.932 37.19 25.197 33.258 47.497-3.932 22.3-25.197 37.19-47.497 33.257-22.3-3.932-37.19-25.197-33.257-47.496 3.932-22.3 25.197-37.19 47.496-33.258zM69 44v-2H17v2h52z",
  fill: "#191919"
})));